module.exports = __webpack_public_path__ + "static/media/DSC_6845-HDR.799a6692.jpg";